export var PaymentProviderType;
(function (PaymentProviderType) {
    PaymentProviderType["WEBPAY"] = "webpay";
    PaymentProviderType["APEXX"] = "apexx";
    PaymentProviderType["VISANET"] = "visanet";
    PaymentProviderType["2C2P"] = "2C2P";
    PaymentProviderType["EWAY"] = "eway";
    PaymentProviderType["MERCADOPAGO"] = "mercadopago";
    PaymentProviderType["STRIPE"] = "stripe";
})(PaymentProviderType || (PaymentProviderType = {}));
//# sourceMappingURL=PaymentProviderType.js.map